import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * RecommendationsApi - axios parameter creator
 * @export
 */
const RecommendationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [to_ent]
         * @param {number} [to_id]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerRecommendation: async (to_ent, to_id, id, options = {}) => {
            const localVarPath = `/v1/Recommendations/DeleteCustomerRecommendation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (to_ent !== undefined) {
                localVarQueryParameter['to_ent'] = to_ent;
            }
            if (to_id !== undefined) {
                localVarQueryParameter['to_id'] = to_id;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationGetAllRequest} [RecommendationGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContributorRecommendation: async (RecommendationGetAllRequest, options = {}) => {
            const localVarPath = `/v1/Recommendations/GetAllContributorRecommendation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RecommendationGetAllRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationGetAllRequest} [RecommendationGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerRecommendation: async (RecommendationGetAllRequest, options = {}) => {
            const localVarPath = `/v1/Recommendations/GetAllCustomerRecommendation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RecommendationGetAllRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByContributorId: async (id, options = {}) => {
            const localVarPath = `/v1/Recommendations/GetByContributorId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByProductId: async (id, options = {}) => {
            const localVarPath = `/v1/Recommendations/GetByProductId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerRecommendation: async (toEntity, toId, options = {}) => {
            const localVarPath = `/v1/Recommendations/GetCustomerRecommendation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (toEntity !== undefined) {
                localVarQueryParameter['toEntity'] = toEntity;
            }
            if (toId !== undefined) {
                localVarQueryParameter['toId'] = toId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerRecommendationsByEntity: async (toEntity, options = {}) => {
            const localVarPath = `/v1/Recommendations/GetCustomerRecommendationsByEntity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (toEntity !== undefined) {
                localVarQueryParameter['toEntity'] = toEntity;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersByEntity: async (toEntity, toId, options = {}) => {
            const localVarPath = `/v1/Recommendations/GetCustomersByEntity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (toEntity !== undefined) {
                localVarQueryParameter['toEntity'] = toEntity;
            }
            if (toId !== undefined) {
                localVarQueryParameter['toId'] = toId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary How many customers recommend the entity and the signed-in customer\'s own recommendation id, for the storefront\'s \"recommend\" button (BW-3930).
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendationSummary: async (toEntity, toId, options = {}) => {
            const localVarPath = `/v1/Recommendations/GetRecommendationSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (toEntity !== undefined) {
                localVarQueryParameter['toEntity'] = toEntity;
            }
            if (toId !== undefined) {
                localVarQueryParameter['toId'] = toId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendations: async (RecommendationToken, options = {}) => {
            const localVarPath = `/v1/Recommendations/GetRecommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RecommendationToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertContributorProductRecommendation: async (RecommendationToken, options = {}) => {
            const localVarPath = `/v1/Recommendations/InsertContributorProductRecommendation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RecommendationToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCustomerProductRecommendation: async (RecommendationToken, options = {}) => {
            const localVarPath = `/v1/Recommendations/InsertCustomerProductRecommendation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RecommendationToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCustomerRecommendation: async (RecommendationToken, options = {}) => {
            const localVarPath = `/v1/Recommendations/InsertCustomerRecommendation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RecommendationToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog,CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/Recommendations/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (RecommendationToken, options = {}) => {
            const localVarPath = `/v1/Recommendations/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RecommendationToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContributorProductRecommendation: async (RecommendationToken, options = {}) => {
            const localVarPath = `/v1/Recommendations/UpdateContributorProductRecommendation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RecommendationToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerProductRecommendation: async (RecommendationToken, options = {}) => {
            const localVarPath = `/v1/Recommendations/UpdateCustomerProductRecommendation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RecommendationToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerRecommendation: async (RecommendationToken, options = {}) => {
            const localVarPath = `/v1/Recommendations/UpdateCustomerRecommendation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RecommendationToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RecommendationsApi - functional programming interface
 * @export
 */
const RecommendationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = RecommendationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [to_ent]
         * @param {number} [to_id]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerRecommendation(to_ent, to_id, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerRecommendation(to_ent, to_id, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.deleteCustomerRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationGetAllRequest} [RecommendationGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllContributorRecommendation(RecommendationGetAllRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllContributorRecommendation(RecommendationGetAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.getAllContributorRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationGetAllRequest} [RecommendationGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCustomerRecommendation(RecommendationGetAllRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCustomerRecommendation(RecommendationGetAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.getAllCustomerRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByContributorId(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByContributorId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.getByContributorId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByProductId(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByProductId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.getByProductId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerRecommendation(toEntity, toId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerRecommendation(toEntity, toId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.getCustomerRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerRecommendationsByEntity(toEntity, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerRecommendationsByEntity(toEntity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.getCustomerRecommendationsByEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersByEntity(toEntity, toId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersByEntity(toEntity, toId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.getCustomersByEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary How many customers recommend the entity and the signed-in customer\'s own recommendation id, for the storefront\'s \"recommend\" button (BW-3930).
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecommendationSummary(toEntity, toId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecommendationSummary(toEntity, toId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.getRecommendationSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecommendations(RecommendationToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecommendations(RecommendationToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.getRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertContributorProductRecommendation(RecommendationToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertContributorProductRecommendation(RecommendationToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.insertContributorProductRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertCustomerProductRecommendation(RecommendationToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertCustomerProductRecommendation(RecommendationToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.insertCustomerProductRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertCustomerRecommendation(RecommendationToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertCustomerRecommendation(RecommendationToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.insertCustomerRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog,CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(RecommendationToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(RecommendationToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContributorProductRecommendation(RecommendationToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContributorProductRecommendation(RecommendationToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.updateContributorProductRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerProductRecommendation(RecommendationToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerProductRecommendation(RecommendationToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.updateCustomerProductRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerRecommendation(RecommendationToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerRecommendation(RecommendationToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.updateCustomerRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RecommendationsApi - factory interface
 * @export
 */
const RecommendationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RecommendationsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [to_ent]
         * @param {number} [to_id]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerRecommendation(to_ent, to_id, id, options) {
            return localVarFp.deleteCustomerRecommendation(to_ent, to_id, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationGetAllRequest} [RecommendationGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContributorRecommendation(RecommendationGetAllRequest, options) {
            return localVarFp.getAllContributorRecommendation(RecommendationGetAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationGetAllRequest} [RecommendationGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerRecommendation(RecommendationGetAllRequest, options) {
            return localVarFp.getAllCustomerRecommendation(RecommendationGetAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByContributorId(id, options) {
            return localVarFp.getByContributorId(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByProductId(id, options) {
            return localVarFp.getByProductId(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerRecommendation(toEntity, toId, options) {
            return localVarFp.getCustomerRecommendation(toEntity, toId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerRecommendationsByEntity(toEntity, options) {
            return localVarFp.getCustomerRecommendationsByEntity(toEntity, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersByEntity(toEntity, toId, options) {
            return localVarFp.getCustomersByEntity(toEntity, toId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary How many customers recommend the entity and the signed-in customer\'s own recommendation id, for the storefront\'s \"recommend\" button (BW-3930).
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendationSummary(toEntity, toId, options) {
            return localVarFp.getRecommendationSummary(toEntity, toId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendations(RecommendationToken, options) {
            return localVarFp.getRecommendations(RecommendationToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertContributorProductRecommendation(RecommendationToken, options) {
            return localVarFp.insertContributorProductRecommendation(RecommendationToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCustomerProductRecommendation(RecommendationToken, options) {
            return localVarFp.insertCustomerProductRecommendation(RecommendationToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCustomerRecommendation(RecommendationToken, options) {
            return localVarFp.insertCustomerRecommendation(RecommendationToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog,CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(RecommendationToken, options) {
            return localVarFp.update(RecommendationToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContributorProductRecommendation(RecommendationToken, options) {
            return localVarFp.updateContributorProductRecommendation(RecommendationToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerProductRecommendation(RecommendationToken, options) {
            return localVarFp.updateCustomerProductRecommendation(RecommendationToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {RecommendationToken} [RecommendationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerRecommendation(RecommendationToken, options) {
            return localVarFp.updateCustomerRecommendation(RecommendationToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RecommendationsApi - object-oriented interface
 * @export
 * @class RecommendationsApi
 * @extends {BaseAPI}
 */
class RecommendationsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {BizwebEntityType} [to_ent]
     * @param {number} [to_id]
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    deleteCustomerRecommendation(to_ent, to_id, id, options) {
        return RecommendationsApiFp(this.configuration).deleteCustomerRecommendation(to_ent, to_id, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {RecommendationGetAllRequest} [RecommendationGetAllRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    getAllContributorRecommendation(RecommendationGetAllRequest, options) {
        return RecommendationsApiFp(this.configuration).getAllContributorRecommendation(RecommendationGetAllRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {RecommendationGetAllRequest} [RecommendationGetAllRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    getAllCustomerRecommendation(RecommendationGetAllRequest, options) {
        return RecommendationsApiFp(this.configuration).getAllCustomerRecommendation(RecommendationGetAllRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    getByContributorId(id, options) {
        return RecommendationsApiFp(this.configuration).getByContributorId(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    getByProductId(id, options) {
        return RecommendationsApiFp(this.configuration).getByProductId(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {BizwebEntityType} [toEntity]
     * @param {number} [toId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    getCustomerRecommendation(toEntity, toId, options) {
        return RecommendationsApiFp(this.configuration).getCustomerRecommendation(toEntity, toId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {BizwebEntityType} [toEntity]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    getCustomerRecommendationsByEntity(toEntity, options) {
        return RecommendationsApiFp(this.configuration).getCustomerRecommendationsByEntity(toEntity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BizwebEntityType} [toEntity]
     * @param {number} [toId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    getCustomersByEntity(toEntity, toId, options) {
        return RecommendationsApiFp(this.configuration).getCustomersByEntity(toEntity, toId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary How many customers recommend the entity and the signed-in customer\'s own recommendation id, for the storefront\'s \"recommend\" button (BW-3930).
     * @param {BizwebEntityType} [toEntity]
     * @param {number} [toId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    getRecommendationSummary(toEntity, toId, options) {
        return RecommendationsApiFp(this.configuration).getRecommendationSummary(toEntity, toId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RecommendationToken} [RecommendationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    getRecommendations(RecommendationToken, options) {
        return RecommendationsApiFp(this.configuration).getRecommendations(RecommendationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {RecommendationToken} [RecommendationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    insertContributorProductRecommendation(RecommendationToken, options) {
        return RecommendationsApiFp(this.configuration).insertContributorProductRecommendation(RecommendationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {RecommendationToken} [RecommendationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    insertCustomerProductRecommendation(RecommendationToken, options) {
        return RecommendationsApiFp(this.configuration).insertCustomerProductRecommendation(RecommendationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {RecommendationToken} [RecommendationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    insertCustomerRecommendation(RecommendationToken, options) {
        return RecommendationsApiFp(this.configuration).insertCustomerRecommendation(RecommendationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog,CMS)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    remove(id, options) {
        return RecommendationsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {RecommendationToken} [RecommendationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    update(RecommendationToken, options) {
        return RecommendationsApiFp(this.configuration).update(RecommendationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {RecommendationToken} [RecommendationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    updateContributorProductRecommendation(RecommendationToken, options) {
        return RecommendationsApiFp(this.configuration).updateContributorProductRecommendation(RecommendationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {RecommendationToken} [RecommendationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    updateCustomerProductRecommendation(RecommendationToken, options) {
        return RecommendationsApiFp(this.configuration).updateCustomerProductRecommendation(RecommendationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {RecommendationToken} [RecommendationToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    updateCustomerRecommendation(RecommendationToken, options) {
        return RecommendationsApiFp(this.configuration).updateCustomerRecommendation(RecommendationToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { RecommendationsApi, RecommendationsApiAxiosParamCreator, RecommendationsApiFactory, RecommendationsApiFp };
//# sourceMappingURL=recommendations-api.js.map
